<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-31 10:42:52
 * @LastEditTime: 2024-03-08 15:48:03
 * @Description:
 * @FilePath: \website\src\components\EventsLine.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->

<template>
    <div class="events-line">
        <div
            class="page-arrow"
            style="transform: translateX(-48px)"
            @click="moveScroll('back')"
        >
            <i class="el-icon-arrow-left"></i>
        </div>
        <div id="events-box">
            <div id="events" :style="{ width: outsideWidth + 'px' }">
                <div
                    class="event-block"
                    v-for="(item, index) in events"
                    :key="index"
                    :style="{
                        top: index % 2 == 1 ? '-64px' : '64px',
                    }"
                    :class="index == 4 || index == 10 ? 'block2016' : ''"
                >
                    <div v-if="index % 2 == 1" class="text-top" slot="">
                        <div class="year">{{ item.year }}</div>
                        <div class="evevt">{{ item.event }}</div>
                    </div>
                    <div class="dot"></div>
                    <div v-if="index % 2 != 1" class="text-bottom">
                        <div class="year">{{ item.year }}</div>
                        <div class="evevt">{{ item.event }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="page-arrow"
            style="transform: translateX(48px)"
            id="arrow-right"
            @click="moveScroll('forward')"
        >
            <i class="el-icon-arrow-right"></i>
        </div>
    </div>
</template>
<script>
export default {
    name: "EventsLine",
    props: {
        events: Array,
    },
    data() {
        return {
            outsideWidth: 0,
        };
    },
    mounted() {
        let conWidth = document.getElementById("events-box").offsetWidth;
        setTimeout(() => {
            this.outsideWidth = 238 * this.events.length - conWidth;
        }, 500);
    },
    methods: {
        moveScroll(flag) {
            let lineLeft = document.getElementById("events").offsetLeft;
            let move = lineLeft;
            let flagNum = this.outsideWidth;
            if (flag == "back") {
                if (lineLeft >= 0) return;
                move += 200;
                moveBack();
            }
            if (flag == "forward") {
                if (lineLeft <= -flagNum) return;
                move -= 200;
                moveForword();
            }

            function moveBack() {
                if (move >= 0) {
                    document.getElementById("events").style.left = "0px";
                } else if (move > lineLeft) {
                    lineLeft += 20;
                    document.getElementById(
                        "events"
                    ).style.left = `${lineLeft}px`;
                    setTimeout(() => {
                        moveBack();
                    }, 10);
                }
            }
            function moveForword() {
                if (move < -flagNum) {
                    document.getElementById(
                        "events"
                    ).style.left = `-${flagNum}px`;
                } else if (move < lineLeft) {
                    lineLeft -= 20;
                    document.getElementById(
                        "events"
                    ).style.left = `${lineLeft}px`;
                    setTimeout(() => {
                        moveForword();
                    }, 10);
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.events-line {
    display: flex;
    align-items: center;
    .page-arrow {
        // background-color: $color-main;
        border: $color-main 2px solid;
        width: 48px;
        line-height: 48px;
        height: 48px;
        border-radius: 50%;
        text-align: center;
        i {
            color: $color-main;
            font-size: $font-size-m;
        }
    }
    .disabled {
        opacity: 0.2;
    }
    #events-box {
        width: calc(100% - 80px);
        overflow: auto;
        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
        position: relative;
        #events {
            display: flex;
            align-items: center;
            height: 540px;
            width: 1524px;
            position: relative;
            .event-block {
                flex-basis: 143px;
                position: relative;
                .dot {
                    height: 3px;
                    width: 238px;
                    background-color: #ffffff;
                    margin: auto;
                    position: relative;
                    &::before {
                        content: "";
                        width: 19px;
                        height: 19px;
                        border-radius: 50%;
                        margin: auto;
                        left: calc(50% - 9px);
                        top: -8px;
                        background-color: #ffffff;
                        position: absolute;
                    }
                }
                .year {
                    font-size: $font-size-l;
                }
                &:hover {
                    .dot::before {
                        background-color: $color-main;
                    }
                    .text-top,
                    .text-bottom {
                        background-color: $color-main;
                        color: #ffffff;
                    }
                }
                .text-top,
                .text-bottom {
                    width: 238px;
                    height: 128px;
                    border-radius: 4px;
                    padding: 20px;
                }
                .text-top,
                .text-bottom {
                    background-color: #ffffff;
                }
                .text-top {
                    transform: translateY(-36px);
                }
                .text-bottom {
                    transform: translateY(36px);
                }
            }
            .block2016 {
                top: 64px;
                .text-bottom {
                    overflow: hidden;
                }
                &:hover {
                    top: 85px !important;
                    .text-bottom {
                        overflow: hidden;
                        height: 170px !important;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/EventsLine.vue